export * from './account.client';
import { AccountClient } from './account.client';
export * from './account-observer.client';
import { AccountObserverClient } from './account-observer.client';
export * from './alert.client';
import { AlertClient } from './alert.client';
export * from './assets.client';
import { AssetsClient } from './assets.client';
export * from './assets-observer.client';
import { AssetsObserverClient } from './assets-observer.client';
export * from './auto-withdrawal.client';
import { AutoWithdrawalClient } from './auto-withdrawal.client';
export * from './cookie-policy.client';
import { CookiePolicyClient } from './cookie-policy.client';
export * from './currency.client';
import { CurrencyClient } from './currency.client';
export * from './equipment-group.client';
import { EquipmentGroupClient } from './equipment-group.client';
export * from './equipment-group-observer.client';
import { EquipmentGroupObserverClient } from './equipment-group-observer.client';
export * from './equipment-model.client';
import { EquipmentModelClient } from './equipment-model.client';
export * from './external-permission-observer.client';
import { ExternalPermissionObserverClient } from './external-permission-observer.client';
export * from './fiat-currency.client';
import { FiatCurrencyClient } from './fiat-currency.client';
export * from './fiat-currency-observer.client';
import { FiatCurrencyObserverClient } from './fiat-currency-observer.client';
export * from './hashrate-chart.client';
import { HashrateChartClient } from './hashrate-chart.client';
export * from './hashrate-chart-observer.client';
import { HashrateChartObserverClient } from './hashrate-chart-observer.client';
export * from './hashrate-unit.client';
import { HashrateUnitClient } from './hashrate-unit.client';
export * from './hashrate-unit-observer.client';
import { HashrateUnitObserverClient } from './hashrate-unit-observer.client';
export * from './income-statistics.client';
import { IncomeStatisticsClient } from './income-statistics.client';
export * from './income-statistics-observer.client';
import { IncomeStatisticsObserverClient } from './income-statistics-observer.client';
export * from './mining-product.client';
import { MiningProductClient } from './mining-product.client';
export * from './mining-reward.client';
import { MiningRewardClient } from './mining-reward.client';
export * from './mining-reward-chart.client';
import { MiningRewardChartClient } from './mining-reward-chart.client';
export * from './mining-reward-chart-observer.client';
import { MiningRewardChartObserverClient } from './mining-reward-chart-observer.client';
export * from './mining-reward-observer.client';
import { MiningRewardObserverClient } from './mining-reward-observer.client';
export * from './mining-statistics.client';
import { MiningStatisticsClient } from './mining-statistics.client';
export * from './mining-statistics-observer.client';
import { MiningStatisticsObserverClient } from './mining-statistics-observer.client';
export * from './pool-info.client';
import { PoolInfoClient } from './pool-info.client';
export * from './profit-calculator.client';
import { ProfitCalculatorClient } from './profit-calculator.client';
export * from './referral-data.client';
import { ReferralDataClient } from './referral-data.client';
export * from './regular-report.client';
import { RegularReportClient } from './regular-report.client';
export * from './support-request.client';
import { SupportRequestClient } from './support-request.client';
export * from './swap-request-observer.client';
import { SwapRequestObserverClient } from './swap-request-observer.client';
export * from './swap-requests.client';
import { SwapRequestsClient } from './swap-requests.client';
export * from './tax-report.client';
import { TaxReportClient } from './tax-report.client';
export * from './transaction.client';
import { TransactionClient } from './transaction.client';
export * from './transaction-observer.client';
import { TransactionObserverClient } from './transaction-observer.client';
export * from './transaction-type.client';
import { TransactionTypeClient } from './transaction-type.client';
export * from './transaction-type-observer.client';
import { TransactionTypeObserverClient } from './transaction-type-observer.client';
export * from './user-code.client';
import { UserCodeClient } from './user-code.client';
export * from './withdrawal.client';
import { WithdrawalClient } from './withdrawal.client';
export * from './worker.client';
import { WorkerClient } from './worker.client';
export * from './worker-observer.client';
import { WorkerObserverClient } from './worker-observer.client';
export const APIS = [AccountClient, AccountObserverClient, AlertClient, AssetsClient, AssetsObserverClient, AutoWithdrawalClient, CookiePolicyClient, CurrencyClient, EquipmentGroupClient, EquipmentGroupObserverClient, EquipmentModelClient, ExternalPermissionObserverClient, FiatCurrencyClient, FiatCurrencyObserverClient, HashrateChartClient, HashrateChartObserverClient, HashrateUnitClient, HashrateUnitObserverClient, IncomeStatisticsClient, IncomeStatisticsObserverClient, MiningProductClient, MiningRewardClient, MiningRewardChartClient, MiningRewardChartObserverClient, MiningRewardObserverClient, MiningStatisticsClient, MiningStatisticsObserverClient, PoolInfoClient, ProfitCalculatorClient, ReferralDataClient, RegularReportClient, SupportRequestClient, SwapRequestObserverClient, SwapRequestsClient, TaxReportClient, TransactionClient, TransactionObserverClient, TransactionTypeClient, TransactionTypeObserverClient, UserCodeClient, WithdrawalClient, WorkerClient, WorkerObserverClient];
